<template>
  <div>
    <div class="container-fluid bg-light py-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t('careerGuidance') }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item"><a href="#">{{ $t('home') }}</a></li>
          <li class="breadcrumb-item text-dark" aria-current="page">{{ $t('careerGuidance') }}</li>
        </ol>
      </div>
    </div>
    <div class="container py-3">
        <p class="animated bounceInDown">{{  $t('school&careerGuidance.summary') }}</p>
        <div v-for="fact in $t('school&careerGuidance.facts')" :key="fact.id">
            <h3 class="text-danger animated bounceInDown">{{ fact.title }}</h3>
            <p class="animated bounceInDown">{{ fact.description }}</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
 
}
</script>

<style>

</style>